<template>
  <div style="width: 100%;height: 100%;overflow:auto;">
  <div v-for="group in templateGroups">
    <div v-if="group.children && group.children.length > 0">
      <div style="line-height: 40px;height: 40px;border: solid 1px #e5e5e5;background-color: whitesmoke">
        <span style="margin-left: 10px;">{{group.name}}</span>
      </div>

      <div class="template-box"  style="margin-left: 50px;padding: 10px;margin-bottom: 10px; ">

        <el-button v-for="template in group.children" :key="template.id" style="width:200px;font-size: 16px;color:#00aaff;"
          @click="showCreatorWindow(template)">
          {{template.name}}
        </el-button>

      </div>

    </div>
  </div>
  </div>

</template>

<script>

import FramePrcRender from "./FramePrcRender";
export default {
  name: "FrameProcessEntry",
  components: {FramePrcRender},
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      templateGroups: []
    }
  },
  methods: {
    async loadTemplates() {
      this.templateGroups = await this.$http('frameProcessService.getUserTemplates')
    },
    showCreatorWindow(template){

      let startNode = template.start_node
      if(!startNode){
        this.$message.error('该流程模板未配置启动节点，请联系管理员！')
        return
      }

      let startNodeProperties = startNode.properties
      if(!startNodeProperties){
        this.$message.error('启动节点属性为空，请联系管理员！')
      }

      var params = {is_component:false, template: template}
      if(startNodeProperties.form_component){
        params.is_component = true;
        params.form_component = startNodeProperties.form_component;
      }else{
        params.form_code = startNodeProperties.form_code;
      }

      let windowObj = {}
      windowObj.icon = "system/tools";
      windowObj.component = "frameTest/process/FrameProcessCreator";
      windowObj.componentParam = '';
      windowObj.name = template.name;
      windowObj.width = 1100 || startNodeProperties.form_width
      windowObj.height = 600 || startNodeProperties.form_height
      windowObj.max = false || startNodeProperties.form_max
      windowObj.parentData = params

      this.$store.dispatch('core/openWindow', windowObj)
    }
  },
  created() {
    this.loadTemplates();
  }
}
</script>


<style lang="less" scoped>
@import '@/global.less';

.myContainer {
  padding: 5px;
}

.dirButtons {
  display: inline-flex;
}

.card-header {
  display: inline-flex;
  height: 36px;
}

.department-name {
  font-size: @fontSizeX;
}


.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.departmentBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.departmentLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.departmentRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.departmentUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}


.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.departmentEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.departmentTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDepartment {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}

:deep(.el-button) {
  margin-left: 12px !important;
  margin-top: 10px !important;
}

</style>
